import toArray from 'lodash.toarray';

/**
 * Counts the length of a string. This uses lodash's `toArray` in order to properly
 * handle multibyte characters such as emojis, accents, etc.
 * (For instance, `'ñ'.length` would return `2`)
 *
 * @param {string} str
 * @returns {number}
 */
const countStringLength = (str) => {
  const chars = toArray(str).length;

  return chars;
};

export default countStringLength;
